import camelCase from 'lodash/camelCase';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import upperFirst from 'lodash/upperFirst';

export const ROLE_INTERNAL_ADMIN = 'ROLE_SUPER_ADMIN';

// Actions
const ADD_USER = 'zen/AppUser/ADD_USER';
const UPDATE_USER = 'zen/AppUser/UPDATE_USER';

const initialState = {
  user: {},
  userId: null,
  prettyName: null,
  highestRole: null,
  isDashboardUser: false,
  isNtk: false,
  isUserMinus: false,
  isUser: false,
  isUserPlus: false,
  isCampaignAdmin: false,
  isAdmin: false,
  isInternalAdmin: false
};

const ALL_ROLES = [
  ROLE_INTERNAL_ADMIN,
  'ROLE_ADMIN',
  'ROLE_CAMPAIGN_ADMIN',
  'ROLE_USER_PLUS',
  'ROLE_NTK',
  'ROLE_USER',
  'ROLE_USER_MINUS',
  'ROLE_DASHBOARD_USER'
];

const _formatRole = (role) => (role === ROLE_INTERNAL_ADMIN ? 'isInternalAdmin' : `is${upperFirst(camelCase(replace(role, 'ROLE', '')))}`);


/**
 * User has metadata, this function generates it and creates
 * a higher object containing this plus the user itself.
 * @param user User object with first name, last name, and everything else.
 * @param currentAccountId The current account ID. Only if present would be attached to the final object.
 * @returns {{
 *    user: object the full info about user,
 *    userId: string the user ID,
 *    prettyName: string the combination of first and last names,
 *    currentAccountId: string the account that user is attached to,
 *    highestRole: string the user highest role,
 *    isAdmin: boolean if the user has this role or not,
 *    isCampaignAdmin: boolean if the user has this role or not,
 *    isInternalAdmin: boolean if the user has this role or not,
 *    isUser: boolean if the user has this role or not,
 *    isUserPlus: boolean if the user has this role or not,
 *  }}
 * @private
 */
const _generateUserMetadata = (user, currentAccountId) => {
  const { id: userId, roles=[], first_name: firstName, last_name: lastName } = user;
  const prettyName = trim(`${firstName || ''} ${lastName || ''}`);
  const userWithMetadata = { user, userId, prettyName };
  if (currentAccountId) {
    userWithMetadata.currentAccountId = currentAccountId;
  }
  roles.forEach((role) => {
    userWithMetadata[_formatRole(role)] = true;
  });
  ALL_ROLES.forEach( (role) => {
    if (!userWithMetadata.highestRole && userWithMetadata[_formatRole(role)]) { userWithMetadata.highestRole = role; }
  });
  return userWithMetadata;
};

// Reducer
const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_USER: {
      const { user={}, accountId: currentAccountId, isAccountThreatLevelEnabled } = payload || {};
      const userObject = _generateUserMetadata(user, currentAccountId);
      return {
        ...state,
        ...userObject,
        isAccountThreatLevelEnabled
      };
    }
    case UPDATE_USER: {
      const userObject = _generateUserMetadata(payload);
      return {
        ...state,
        ...userObject
      };
    }
    default: return state;
  }
};

// Action Creators
const addUserToStore = (payload) => {
  return { type: ADD_USER, payload };
};

const updateUser = (payload) => {
  return { type: UPDATE_USER, payload };
};

export default reducer;
export {
  // Actions
  ADD_USER,
  UPDATE_USER,
  // Action Creators
  addUserToStore,
  updateUser
};




